import Image from "next/image";
import Link from "next/link";

export const PressReleaseMarketing = () => {
	return (
		<div className="mt-6 flex h-max w-full flex-col flex-wrap items-center justify-center gap-10 bg-gradient-to-r from-[#005AFA] via-[#5992F4] to-[#005AFA] px-6 py-7 lg:flex-row lg:gap-x-28 lg:px-14">
			<div className="flex flex-col items-center space-y-6 text-center lg:items-start lg:space-y-[26px] lg:text-left">
				<div className="flex w-full flex-col items-center gap-3 lg:w-[720px] lg:items-start">
					<span className="text-xl font-semibold text-white lg:text-[26px]">
						Reimagine Your Press Release
					</span>
					<span className="text-sm text-white lg:text-base">
						Maximize your impact with Industry platform. Share your news directly with our engaged
						community and amplify your reach with premium distribution options.
					</span>
				</div>
				<div className="flex flex-wrap justify-center gap-6 text-sm font-medium lg:justify-start lg:text-[13px]">
					<div className="flex w-[230px] flex-col items-center gap-3 lg:items-start">
						<span className="rounded bg-white px-2 py-1 text-[#4988F5]">Direct Distribution</span>
						<span className="text-white">Get featured on our platform for maximum visibility.</span>
					</div>

					<div className="flex w-[230px] flex-col items-center gap-3 lg:items-start">
						<span className="rounded bg-white px-2 py-1 text-[#4988F5]">Community Exposure</span>
						<span className="text-white">
							Engage with industry professionals and decision-makers.
						</span>
					</div>

					<div className="flex w-[230px] flex-col items-center gap-3 lg:items-start">
						<span className="rounded bg-white px-2 py-1 text-[#4988F5]">Extended PR Services</span>
						<span className="text-white">
							Expand your reach with podcast features, social media promotions, and newsletter
							spotlights.
						</span>
					</div>
				</div>
				<Link
					href="/news/press-release"
					className="flex flex-wrap items-center justify-center gap-1 rounded-l-md rounded-r-md bg-white py-2 pl-4 text-sm sm:rounded-r-3xl sm:py-0"
				>
					<span className="m-0 text-[#4988F5]">Amplify Your PropTech Story</span>{" "}
					<span className="m-0 rounded-full bg-[#FBA805] px-4 py-[10px] text-white">
						Submit & Get Featured
					</span>
				</Link>
			</div>

			<Image
				src={"/images/press-release-marketing.png"}
				alt="Press Release Marketing"
				className="h-48 w-80 rounded lg:h-64 lg:w-[350px]"
				width={1080}
				height={480}
			/>
		</div>
	);
};
